import React from 'react';
import { useIntl } from 'react-intl';
import { TableFieldCells, TableFieldColumn } from '@eas/common-web';
import { Redirect } from '@components/redirect/redirect';
import { Operation } from '@models';
import { EvidenceBrowserUrl } from '@enums';

export function useColumns({
  hideRedirectInCurrent,
}: {
  hideRedirectInCurrent?: boolean;
}): TableFieldColumn<Operation>[] {
  const intl = useIntl();

  return [
    {
      name: intl.formatMessage({
        id: 'ZSD__ACTIVITIES__TABLE__COLUMN__WORK_ORDER',
        defaultMessage: 'Pracovný príkaz',
      }),
      datakey: 'workOrder.workOrderId',
      sortkey: 'workOrder.workOrderId',
      width: 150,
      CellComponent: function Cell(props) {
        return (
          <>
            <Redirect
              url={EvidenceBrowserUrl.WORK_ORDERS}
              id={props.rowValue!.workOrder?.id ?? ''}
              showRedirectInCurrent={!hideRedirectInCurrent}
            />
            {props.rowValue!.workOrder?.workOrderId}
          </>
        );
      },
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__ACTIVITIES__TABLE__COLUMN__FILLED_FORM',
        defaultMessage: 'Vyplnený formulár',
      }),
      datakey: 'filledForm.id',
      sortkey: 'filledForm.id',
      width: 150,
      CellComponent: function Cell(props) {
        return (
          <>
            {props.rowValue!.filledForm?.id && props.rowValue.workOrder?.id && (
              <Redirect
                url={`${EvidenceBrowserUrl.FILLED_FORMS}/${
                  props.rowValue!.workOrder?.id
                }/${props.rowValue!.filledForm?.id}`}
                id={'filler'}
                showRedirectInCurrent={!hideRedirectInCurrent}
              />
            )}
          </>
        );
      },
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__OPERATIONS__TABLE__COLUMN__TYPE_CODE',
        defaultMessage: 'Kód úkonu',
      }),
      datakey: 'type.code',
      sortkey: 'type.code',
      width: 100,
      CellComponent: TableFieldCells.TextCell,
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__OPERATIONS__TABLE__COLUMN__TYPE',
        defaultMessage: 'Typ',
      }),
      datakey: 'type.name',
      sortkey: 'type.name',
      width: 200,
      CellComponent: TableFieldCells.TextCell,
    },
    // {
    //   name: intl.formatMessage({
    //     id: 'ZSD__OPERATIONS__TABLE__COLUMN__PERFORMED',
    //     defaultMessage: 'Vykonaný',
    //   }),
    //   datakey: 'performed',
    //   sortkey: 'performed',
    //   width: 100,
    //   CellComponent: TableFieldCells.BooleanCell,
    // },
    {
      name: intl.formatMessage({
        id: 'ZSD__OPERATIONS__TABLE__COLUMN__DESCRIPTION',
        defaultMessage: 'Popis',
      }),
      datakey: 'description',
      sortkey: 'description',
      width: 300,
      CellComponent: TableFieldCells.TextCell,
    },
  ];
}
